enum SocialProvider {
  GOOGLE = "GOOGLE",
  APPLE = "APPLE",
  FACEBOOK = "FACEBOOK",
}

export default SocialProvider;
